
const LoaderInfoList = () => {

    return (
        <div className="info-list">
            <div className="block-title">
                <h6 className="title">کاری که من انجام می دهم</h6>
            </div>
            <div className="row">

                <div className="col-sm-6">
                    <div className="info-list-item shimmerBox">
                        <div className="shine shimmerBoxIn mb-2"></div>
                        <div className="title-info"><div className="shine shimmerLine"></div></div>
                        <div className="des">
                            <div className="shine shimmerLine"></div>
                            <div className="shine shimmerLine"></div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="info-list-item shimmerBox">
                        <div className="shine shimmerBoxIn mb-2"></div>
                        <div className="title-info"><div className="shine shimmerLine"></div></div>
                        <div className="des">
                            <div className="shine shimmerLine"></div>
                            <div className="shine shimmerLine"></div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="info-list-item shimmerBox">
                        <div className="shine shimmerBoxIn mb-2"></div>
                        <div className="title-info"><div className="shine shimmerLine"></div></div>
                        <div className="des">
                            <div className="shine shimmerLine"></div>
                            <div className="shine shimmerLine"></div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="info-list-item shimmerBox">
                        <div className="shine shimmerBoxIn mb-2"></div>
                        <div className="title-info"><div className="shine shimmerLine"></div></div>
                        <div className="des">
                            <div className="shine shimmerLine"></div>
                            <div className="shine shimmerLine"></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default LoaderInfoList;